

































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalProjectIntention",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalProjectIntention extends Vue {
  get fetchData() {
    return api.externalProjectIntention.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProjectLetterIntent-detail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
